<template>
    <tbody class="mds-data-table__body">
      <template v-if="!isEmpty">
        <template v-for="(rowData, row) in data">
            <tr class="mds-data-table__row level-0"
                :data-row="row"
                :key="rowData.id || row"
                :class="{
                    'children-hidden': !areChildrenDisplayed(rowData),
                    'parent-row': isParentRow(rowData),
                    'before-parent-row': isBeforeHasChildrenElement(row, data)
                      && !isParentRow(rowData)
                }"
                role="row"
            >
                <BodyCell
                    v-for="(config, col) in columnsConfig"
                    :key="col"
                    :align="config.align"
                    :width="config.width"
                    :nowrap="config.nowrap"
                    :class="config.bodyClass"
                    :style="config.bodyStyle"
                >
                    <slot
                        name="cell"
                        :content="rowData[config.key]"
                        :columnKey="config.key"
                        :row="row"
                        :col="col"
                    >
                        {{ nullableTableValue(rowData[config.key]) }}
                    </slot>
                </BodyCell>
            </tr>
            <template v-if="Array.isArray(rowData.subs) && rowData.subs.length > 0">
                <template
                    v-for="(subData, subRow) in rowData.subs"
                >
                    <tr
                        :data-row="`${row}-${subRow}`"
                        :key="subData.id || `${row}-${subRow}`"
                        class="mds-data-table__row level-1 child-row"
                        :class="{
                            'last-child-row': isLastOfGroup(subRow, rowData.subs),
                            'before-parent-row': isBeforeHasChildrenElement(row, data)
                              && isLastOfGroup(subRow, rowData.subs)
                        }"
                        role="row"
                        v-show="areChildrenDisplayed(subData)"
                    >
                        <BodyCell
                            v-for="(config, col) in columnsConfig"
                            :key="col"
                            :align="config.align"
                            :width="config.width"
                            :nowrap="config.nowrap"
                            :class="config.bodyClass"
                            :style="config.bodyStyle"
                        >
                            <slot
                                name="cell"
                                :content="subData[config.key]"
                                :columnKey="config.key"
                                :row="row"
                                :col="col"
                                :sub="subRow"
                            >
                                {{ nullableTableValue(subData[config.key]) }}
                            </slot>
                        </BodyCell>
                    </tr>
                </template>
            </template>
        </template>
      </template>
      <template v-else>
        <tr class="mds-data-table__row level-0 empty-data" >
          <td :colspan="columnsConfig.length" class="empty-data__column">
            <slot name="empty-message">No data found</slot>
          </td>
        </tr>
      </template>
    </tbody>
</template>

<script>
import { nullableTableValue, isDef } from '@/utils/data-table';
import BodyCell from '@/components/molecules/data-table/body-cell';

export default {
  components: { BodyCell },

  props: {
    data: { type: Array, default: () => [] },
    columnsConfig: { type: Array, default: () => [] },
  },

  methods: {
    nullableTableValue,
    isDef,
    isParentRow(rowData) {
      return rowData && rowData.subs && rowData.subs.length > 0;
    },
    areChildrenDisplayed(subData) {
      return !(isDef(subData.__hidden) && subData.__hidden);
    },
    isBeforeHasChildrenElement(index, data) {
      const nextItem = data[index + 1];
      if (typeof nextItem !== 'undefined') {
        return nextItem.subs && nextItem.subs.length > 0;
      }
      return false;
    },
    isLastOfGroup(index, data) {
      return index === Object.keys(data).length - 1;
    },
  },
  computed: {
    isEmpty() {
      return this.data.length === 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.mds-data-table__row td {
    line-height: 30px;
}
.empty-data__column {
  text-align: center;
}
</style>
